import { Directive, nextTick } from 'vue'

export const AutoFocus: Directive = {
  async mounted (el: HTMLElement) {
    await nextTick()
    el.focus()
  },
}
